import { t } from 'i18next';
import React, { useEffect } from 'react';
import { View } from 'react-native';
import { useStyles } from 'react-native-unistyles';
import SignatureCanvas from 'react-signature-canvas';

import { Button, Text } from '@/ui';

interface IProps {
  onDone: (signature: string) => void;
  onClear: () => void;
  initSignature?: string;
  onBegin?: () => void;
  onEnd?: () => void;
  text?: string;
}

export const Canvas = ({
  onDone,
  onClear,
  initSignature,
  onBegin,
  onEnd,
  text,
}: IProps) => {
  const { theme } = useStyles();
  const sigCanvas = React.useRef<SignatureCanvas>(null);
  const [signature, setSignature] = React.useState<string | undefined>(
    initSignature || ''
  );

  useEffect(() => {
    if (sigCanvas.current?.isEmpty() && signature) {
      sigCanvas.current.fromDataURL(signature);
    }
  }, [signature]);

  return (
    <View
      style={{
        width: '100%',
        borderColor: theme.colors.input.default.border,
        borderRadius: 16,
        borderWidth: 1,
      }}
    >
      <View style={{ width: '100%' }}>
        <SignatureCanvas
          ref={sigCanvas}
          penColor={theme.colors.text.primary}
          backgroundColor={theme.colors.background_3}
          onBegin={() => {
            onBegin?.();
          }}
          onEnd={() => {
            onDone(sigCanvas.current?.toDataURL()!);
            setSignature(sigCanvas.current?.toDataURL());
            onEnd?.();
          }}
          minWidth={1}
          maxWidth={1}
          dotSize={1}
          canvasProps={{
            style: {
              width: '100%',
              height: 180,
              borderTopLeftRadius: 16,
              borderTopRightRadius: 16,
            },
          }}
          clearOnResize={false}
        />
      </View>

      <View>
        <View
          style={{
            flexDirection: 'row',
            padding: 16,
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Text type="bodyRegular" style={{ width: '70%' }}>
            {text || t('canvas.sign')}
          </Text>

          <Button
            tx="canvas.clear"
            type="primary"
            onPress={() => {
              onClear();
              setSignature('');
              sigCanvas.current?.clear();
            }}
            style={{ width: 80, borderRadius: 100 }}
            disabled={!signature}
          />
        </View>
      </View>
    </View>
  );
};
